import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

// Split a phrase into words and wrap each in a mask
export const MaskedLine = ({ children, delay = 0, className = '' }) => {
    const words = String(children).split(' ');
    return (
        <span className={`inline-block ${className}`}>
            {words.map((word, i) => (
                <span
                    key={i}
                    className="mask-reveal"
                    style={{ marginInlineEnd: '0.25em' }}
                >
                    <motion.span
                        initial={{ y: '110%' }}
                        animate={{ y: '0%' }}
                        transition={{
                            duration: 1.1,
                            ease: EASE,
                            delay: delay + i * 0.05,
                        }}
                    >
                        {word}
                    </motion.span>
                </span>
            ))}
        </span>
    );
};

export const RevealOnScroll = ({ children, delay = 0, y = 30, className = '' }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 1, ease: EASE, delay }}
        className={className}
    >
        {children}
    </motion.div>
);
